import React from "react";
import { useConfig } from "@nusrif/contexts";

interface MarqueeProps {
  text?: string;
}

export const Marquee: React.FC<MarqueeProps> = ({ text }) => {
  const config = useConfig();
  const defaultMsg = `Flat 25% launch offer • Free delivery on orders above ₹${config.minimumOrderValueForFreeDelivery} • Fast home delivery with our quickest available mode`;
  const message = config.marqueeText ?? text ?? defaultMsg;
  return (
    <div className="w-full overflow-hidden bg-primary-blue text-white">
      <div className="relative whitespace-nowrap py-2 select-none">
        <div
          className="inline-block px-4 font-semibold text-white"
          style={{
            animation: "marquee 18s linear infinite",
            willChange: "transform",
          }}
        >
          <span className="mr-8 text-white">{message}</span>
          <span className="mr-8 text-white">{message}</span>
        </div>
      </div>
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
};


